import { Component, inject, input, signal } from '@angular/core';
import { isChildOf } from 'src/app/utils/dom';
import { IonIcon } from "@ionic/angular/standalone";
import { RouterModule } from '@angular/router';
import { LocalizationModule } from 'src/app/modules/localization/localization.module';
import { PopoverButtonsService } from 'src/app/services/popover-buttons.service';

@Component({
  selector: 'app-popover-buttons',
  templateUrl: './popover-buttons.component.html',
  styleUrls: ['./popover-buttons.component.scss'],
  standalone: true,
  imports: [IonIcon, RouterModule, LocalizationModule]
})
export class PopoverButtonsComponent {
  popoverButtonsService = inject(PopoverButtonsService);

  label = input<string | null | undefined>();
  buttons = input.required<PopoverButton[]>();
  isOpen = signal(false);

  constructor() {
    this.popoverButtonsService.closeHandler = (event: Event) => {
      const isInThisComponent = isChildOf(event.target as HTMLElement, 'app-popover-buttons');
      if (isInThisComponent) return;
      this.isOpen.set(false);
    };
  }
}

export interface PopoverButton {
  label?: string;
  icon?: string;
  href?: string;
  action?: (event: Event) => any;
  isDivider?: boolean;
}